export default "__VITE_ASSET__BeBeE_L$__"